import { ColorPicker } from '@shared/components/ColorPicker';
import { useCallback } from 'react';
import { useUpdateUserMutation, useUserDataQuery } from '@shared/queries';
import { useAnalytics } from '@libs/mixpanel/useAnalytics';

const ProfileColorPicker = () => {
  const { data: userData } = useUserDataQuery();
  const { mutation: updateUserData } = useUpdateUserMutation();
  const { trackEvent } = useAnalytics();

  const handleSave = useCallback(
    (color: string) => {
      updateUserData.mutate({ colorScheme: color });
      trackEvent('color_scheme_changed', { color });
    },
    [updateUserData],
  );

  return <ColorPicker initialColor={userData?.colorScheme ?? '#c81f5b'} onSave={handleSave} />;
};

export default ProfileColorPicker;
